package app.bloomey.web.modules.analytics

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.TimesSeriesData

object AnalyticsContract {
    data class State(
        val totalUsers: UiState<List<TimesSeriesData<Long>>> = UiState.Initial,
        val monthlyActiveUsers: UiState<List<TimesSeriesData<Long>>> = UiState.Initial,
        val dailyActiveUsers: UiState<List<TimesSeriesData<Long>>> = UiState.Initial,
        val newUsers: UiState<List<TimesSeriesData<Long>>> = UiState.Initial,
    )

    sealed interface Inputs {
        data object GetTotalUsers : Inputs
        data object MonthlyActiveUsers : Inputs
        data object DailyActiveUsers : Inputs
        data object NewUsers : Inputs
    }

    sealed interface Events
}
